export default __webpack_public_path__ + "static/NotoSans-Medium-a4c42b7a92bf0fdb8ec12731d63248ae.ttf";